import { StateCreator } from 'zustand'

import { AudienceEntity } from '../types'

interface AudiencesState {
  audiences: AudienceEntity[]
}

interface AudiencesActions {
  addAudience: (audience: AudienceEntity) => void
  setAudiences: (audiences: AudienceEntity[]) => void
}

export type AudiencesSlice = AudiencesState & AudiencesActions

export const initialAudiencesState: AudiencesState = {
  audiences: [],
}

const createAudiencesSlice: StateCreator<AudiencesSlice, [], [], AudiencesSlice> = (set, get) => ({
  ...initialAudiencesState,
  addAudience: (newAudience) => set((state) => ({ audiences: [...state.audiences, newAudience] })),
  setAudiences: (audiences) => {
    const prevAudiences = get().audiences
    if (JSON.stringify(prevAudiences) !== JSON.stringify(audiences)) {
      set({ audiences })
    }
  },
})

export default createAudiencesSlice
